<template lang="html">
    <div class="previewSCCL-page">
        <Slogan theTitle="上传材料"/>
        <div class="fd-files-box" v-if="sqsFiles.length !== 0">

            <template v-if="isSQBG">
                <h5>变更担保申请书</h5>
                <!-- <div class="fd-img-box" v-for="(item,index) in this.sqsFiles" :key="index">
                    <img :src="item.url" alt="">
                </div> -->
                <van-uploader
                    class="uploader"
                    multiple
                    v-model="this.bgdbsqsFiles"
                    :deletable="false"
                    :max-count="0"
                    disabled/>
                <div class="block"></div>
            </template>


            <h5>{{isSQBG?'变更后保全':'保全'}}申请书</h5>
            <!-- <div class="fd-img-box" v-for="(item,index) in this.sqsFiles" :key="index">
                <img :src="item.url" alt="">
            </div> -->
             <van-uploader
                class="uploader"
                multiple
                v-model="this.sqsFiles"
                :deletable="false"
                :max-count="0"
                disabled/>
            <div class="block"></div>
        </div>
        <div class="fd-files-box" v-if="qszFiles.length !== 0">
            <h5>{{isSQBG?'变更后':''}}起诉状</h5>
            <!-- <div class="fd-img-box" v-for="(item,index) in this.qszFiles" :key="index">
                <img :src="item.url" alt="">
            </div> -->
            <van-uploader
                class="uploader"
                multiple
                v-model="this.qszFiles"
                :deletable="false"
                :max-count="0"
                disabled/>
            <div class="block"></div>
        </div>
        <div class="fd-files-box" v-if="lasltzsFiles.length !== 0">
            <h5>立案受理通知书</h5>
            <!-- <div class="fd-img-box" v-for="(item,index) in this.lasltzsFiles" :key="index">
                <img :src="item.url" alt="">
            </div> -->
             <van-uploader
                class="uploader"
                multiple
                v-model="this.lasltzsFiles"
                :deletable="false"
                :max-count="0"
                disabled/>
            <div class="block"></div>
        </div>
        <div class="fd-files-box" v-if="sfzmFiles.length !== 0">
            <h5>身份证明类</h5>
            <div class="fd-sfzmImg-box" v-for="(item,index) in this.sfzmFiles" :key="index">
                <template v-if="item.clList.length>0">
                    <h4 class="sfzm-person">{{item.rymc}}</h4>
                    <!-- <div class="fd-sfzm-box" v-for="(itemSfz,indexSfz) in item.clList" :key="indexSfz">
                        <img :src="itemSfz.url" alt="">
                    </div> -->
                    <van-uploader
                        multiple
                        v-model="item.clList"
                        :deletable="false"
                        :max-count="0"
                        disabled/>
                </template>
            </div>
            <div class="block"></div>
        </div>
        <div class="fd-files-box" v-if="zjFiles.length !== 0">
            <h5>证据类</h5>
            <!-- <div class="fd-img-box" v-for="(item,index) in this.zjFiles" :key="index">
                <img :src="item.url" alt="">
            </div> -->
            <van-uploader
                class="uploader"
                multiple
                v-model="this.zjFiles"
                :deletable="false"
                :max-count="0"
                disabled/>
            <div class="block"></div>
        </div>
        <div class="fd-files-box" v-show="qtFiles.length !== 0">
            <h5>其他</h5>
            <!-- <div class="fd-img-box" v-for="(item,index) in this.qtFiles" :key="index">
                <img :src="item.url" alt="">
            </div> -->
             <van-uploader
                class="uploader"
                multiple
                v-model="this.qtFiles"
                :deletable="false"
                :max-count="0"
                disabled/>
            <div class="block"></div>
        </div>
    </div>
</template>

<script>
    import Slogan from '../../../components/common/slogan'

    export default {
        components: {
            Slogan
        },
        data() {
            return {
                bgdbsqsFiles: [],// 变更后担保申请书
                sqsFiles: [],//申请书
                qszFiles: [],//起诉状
                lasltzsFiles: [],//立案受理通知书
                sfzmFiles: [],//身份证明
                dblFiles: [],//担保类
                zjFiles: [],//证据类
                qtFiles: [],
                bz: "",

                dbjbxxData:{},
            }
        },
        computed: {
            isSQBG(){
                var dbjbxxData=this.dbjbxxData;
                if(Object.keys(dbjbxxData).length>0&&(['11','12'].includes(dbjbxxData.cDbzt)||(dbjbxxData.cDbzt==='5'&&dbjbxxData.nSfbgwc>0))){
                    return true;
                }else{
                    return false;
                }
            }
        },
        methods: {
            getCcxsList() {
                let Id = window.sessionStorage.getItem("dbid")
                this.$axios.get('ssbq/api/ssdb/sccls' + "?time=" + new Date().getTime() + "&dbid=" + Id).then(res => {
                    this.bgdbsqsFiles=res.data.bgdbsqs;
                    this.sqsFiles = res.data.sqs
                    this.qszFiles = res.data.qsz
                    this.lasltzsFiles = res.data.lasltzs
                    this.sfzmFiles = res.data.sfzml
                    this.zjFiles = res.data.zjl
                    this.qtFiles = res.data.qt
                })
            },
            getGuaranteeBasic() {
                let Id = window.sessionStorage.getItem("dbid");
                this.$axios.get('ssbq/api/ssdb/dbjbxx' + "?time=" + new Date().getTime() + "&dbid=" + Id).then(res => {
                    console.log('--dbjbxx 345',res);
                    this.dbjbxxData=res.data;
                });
            }
        },
        mounted() {
            this.getGuaranteeBasic()
            this.getCcxsList()
        }
    }
</script>

<style lang="less" scoped>
    .fd-files-box {
        width: 100%;
        background: #fff;

        > h5 {
            line-height: 40px;
            margin-left: 16px;
            font-size: 15px;
            font-weight: bold;
        }

        .sfzm-person {
            color: #333;
            line-height: 40px;
        }

        .fd-img-box {
            width: 100px;
            height: 100px;
            margin-left: 16px;
            margin-top: 10px;
            margin-bottom: 10px;

            > img {
                width: 100%;
                height: 100%;
            }

            .fd-sfzm-box {
                width: 100%;
                height: 100%;

                > img {
                    width: 100%;
                    height: 100%;
                }
            }
        }

        .fd-sfzmImg-box {
            margin-left: 16px;
            margin-bottom: 10px;

            .fd-sfzm-box {
                width: 100px;
                height: 100px;

                > img {
                    width: 100%;
                    height: 100%;
                }
            }

        }

    }
</style>
